import standard from "./standard.js";
export default [standard];
